import { getTvObject, tv } from '@costar-ui/cosmos';

var baseTV = getTvObject({
  base: ['relative', 'flex', 'group', 'gap-2', 'h-fit', 'transition', 'w-full'],
  variants: {
    size: {
      inherit: ['text-e-1.0'],
      //xs: ['text-p-10'],
      //sm: ['text-p-12'],
      md: ['text-p-16']
      //lg: ['text-p-20'],
      //xl: ['text-p-24'],
      //'2xl': ['text-p-28'],
      //'3xl': ['text-p-32']
    },
    checkboxAlignment: {
      center: 'items-center',
      top: 'items-start'
    },
    isReadOnly: {
      "false": 'cursor-pointer'
    },
    isDisabled: {
      "true": 'cursor-not-allowed'
    }
  }
});
var baseStyles = tv(baseTV);

export { baseStyles, baseTV };
//# sourceMappingURL=checkbox-base.styles.esm.js.map
